<div class="bg-white p-4 rounded-md shadow-lg">
  @if (currentMonthSubject | async) {
    <div class="flex flex-row justify-between mb-4">
      <div class="text-lg font-bold">
        {{
        { date: $any(currentMonthSubject | async).startDate, localeStringFormat: { month: 'long', year: 'numeric' }, timezone: timezone() }
        | luxon
        }}
      </div>
      <div class="flex flex-row space-x-4">
        <button (click)="previousMonth()"><ng-icon name="heroChevronLeft"></ng-icon></button>
        <button (click)="nextMonth()"><ng-icon name="heroChevronRight"></ng-icon></button>
      </div>
    </div>
    <div class="calendar">
      <div class="week-days">
        @for (day of $any(currentMonthSubject | async).weeks[0].days; track day) {
          <div class="day">
            {{ { date: day.date, format: 'EEEEE', timezone: timezone() } | luxon }}
          </div>
        }
      </div>
      @for (week of $any(currentMonthSubject | async).weeks; track week) {
        <div class="week">
          <div class="week-number">{{ week.weekNumber }}</div>
          @for (day of week.days; track day) {
            <div
              class="day"
              [class.active-month]="day.active"
              [class.today]="day.today"
              [class.selected]="isDateSelected(day.date)"
              (click)="select(day.date)"
              >
              {{ day.date.day }}
            </div>
          }
        </div>
      }
    </div>
  }
</div>
